import { PageWrapper } from "@/components/Common/PageWrapper/PageWrapper";
import { Formik } from "formik";
import { ClusterType, SimpleClusterForm } from "@/types";
import { CreateVirtualMachineFormV2 } from "@/components/ClustersPage/CreateVirtualMachineFormV2/CreateVirtualMachineFormV2";
import { createClusterData, newInitialFormValues } from "@/store/simpleCluster";
import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

const createVirtualMachineFormData = {
  ...createClusterData,
  sshKeys: [],
  selectedSshKeyIds: [],
  networkServices: []
};

const CreateVirtualMachinePageV2 = () => {
  const initialValues = useMemo(() => {
    const baseValues = {
      ...newInitialFormValues,
      durationType: "hourly",
      durationQuantity: 1,
      replicaCount: "1",
      createClusterData: createVirtualMachineFormData,
      clusterType: ClusterType.VMAAS,
      vmImageType: "general",
      sshType: "manual",
      sshKeys: [] as SimpleClusterForm["sshKeys"],
      selectedSshKeyIds: [] as string[],
      networkServices: [],
      name: `vm-${uuidv4().split("-")[0]}`,
      currency: "credits" as "stripe" | "iocoin" | "usdc" | "credits"
    };
    return baseValues;
  }, []);

  return (
    <PageWrapper>
      <Formik<SimpleClusterForm>
        initialValues={initialValues}
        onSubmit={(values) => console.log(values)}
        validateOnMount={true}
        enableReinitialize={true}
      >
        <CreateVirtualMachineFormV2 formData={createVirtualMachineFormData} />
      </Formik>
    </PageWrapper>
  );
};

export default CreateVirtualMachinePageV2;
